import React, { Component } from 'react';
import Highlight from 'react-highlight';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import { 
    EMBED_BUTTON_CODE,
    EMBED_BUTTON_IMG
} from '../../config';

class EmbedButton extends Component {

    constructor(props){
        super(props);
        this.state = {
            size: "small",
            colour: "honeycomb",
            display: "left",
            copied: false,
        }

        this.modalActive = false;
    }

    /**
     * Changes active colour of Honeycomb button to new size.
     * Alternates between large and small
     */
    toggleSize(){
        let newSize = this.state.size == "large" ? "small" : "large";
        this.setState({size: newSize, copied: false});
    }

    /**
     * Changes how the modal is displayed
     * @param {String} method 
     */
    toggleDisplay(method){
        this.setState({display: method});
    }

    /**
     * Changes active colour of Honeycomb button to new colour
     * @param colour : Name of new colour
     */
    toggleActiveColour(colour){
        this.setState({colour, copied: false});
    }

    /**
     * Opens webapp for this restaurant
     */
    buttonClickHandler() {
        window.open("https://app.honeycomb.ai/" + this.props.restaurantURL, "_blank");
    }

    /**
     * Renders buttons allowing user to choose size of button
     */
    get sizeSelector(){
        return(
            <div>
                <div>
                    select style
                </div>
                <div className="btn-group" id="selectorButtons" role="group" aria-label="Basic example">
                    <button 
                        id="button-selector-small" 
                        className={
                            this.state.size == "large" 
                                ? "activeSelectorButton" : "inactiveSelectorButton"
                        }
                        onClick={()=>this.toggleSize()}
                    >
                        Style 1
                    </button>
                    <button 
                        id="button-selector-small"
                        className={
                            (this.state.size == "small" 
                                ? "activeSelectorButton" : "inactiveSelectorButton") 
                        }
                        onClick={()=>this.toggleSize()}
                    >
                        Style 2
                    </button>
                </div>
            </div>
        )
    }

    /**
     * Render method of displaying modal
     */
    get displayPicker(){
        return(
            <div>
                <div>
                    select display method
                </div>
                <div className="btn-group" id="selectorButtons" role="group" aria-label="Basic example">
                    <button 
                        id="button-selector-small" 
                        className={
                            this.state.display == "left" 
                                ? "activeSelectorButton" : "inactiveSelectorButton"
                        }
                        onClick={()=>this.toggleDisplay('left')}
                    >
                        Slide Left
                    </button>
                    <button 
                        id="button-selector-small"
                        className={
                            (this.state.display == "full" 
                                ? "activeSelectorButton" : "inactiveSelectorButton") 
                        }
                        onClick={()=>this.toggleDisplay('full')}
                    >
                        Slide Full
                    </button>
                    <button 
                        id="button-selector-small"
                        className={
                            (this.state.display == "right" 
                                ? "activeSelectorButton" : "inactiveSelectorButton") 
                        }
                        onClick={()=>this.toggleDisplay('right')}
                    >
                        Slide Right
                    </button>
                </div>
            </div>
        )
    }

    /**
     * Render a demonstration of the embed button
     * 
     */
    get demoButton() {
        return(
            <div className="sampleButtonImage"
                onClick={() => window.open("https://app.honeycomb.ai/" + this.props.restaurantURL, "_blank")}
            >
                <img
                    width="200px"
                    src={`https://www.honeycomb.ai/button-${this.state.colour}-${this.state.size}.svg`}
                />
            </div>
        );
    }

    /**
     * Generates divs for all variations of buttons
     */
    get createAllButtons() {
        return (
            <div>
                <div>try me! opens in new tab.</div>
                    {this.demoButton}
            </div>
        );
    }

    /**
     * Render component that shows the code for user's button
     */
    get codeHighlight() {
        return (
            <div className="highlightedCode">
                {this.copiedToClipboardText}
                <Highlight language="html">
                    {EMBED_BUTTON_CODE(this.props.restaurantURL, this.state.size, this.state.colour, this.state.display)}
                </Highlight>
            </div>
        )
    }

    /**
     * Return component that contains button that copies embed code to clipboard
     */
    renderClipboardCopier(clipText){
        return (
            <CopyToClipboard
                text={clipText}
                onCopy={() => {
                    if(!this.state.copied) {
                        setTimeout(() => {
                            this.setState({copied: false})
                        }, 1000);
                    }
                    this.setState({copied: true})
                }}
            >
                <button className="copyClipboardButton">Copy To Clipboard</button>
            </CopyToClipboard>
        )
    }

    /**
     * Return text to display if button is copied
     */    
    get copiedToClipboardText(){
        return(
            <div className="copiedTextWrapper">
                <span
                    className = "copiedText" 
                    id={this.state.copied ? "copiedText-show" : "copiedText-hide"}
                >Copied!
                </span>
            </div> 
        )
    }

    /**
     * Returns the set of available colours to pick from
     * 
     * TODO ARTH: Remove inline styling
     * 
     */
    get colourPalette() {
        let colours = []
        for (let colour of Object.keys(this.props.colours)){
            colours.push(
                <div
                    className="colour" 
                    style={{
                            backgroundColor: this.props.colours[colour], 
                            display: 'inline-block'
                        }}
                    key={colour}
                    onClick={() => this.toggleActiveColour(colour)}
                >
                </div>
            )
        }
        return (
            <div>
                <div> select colour </div>
                <div className="colourPalette">{colours}</div>
            </div>
        )
    }


    get slider(){
        return(
            <div className="slidecontainer">
                <input type="range" min="1" max="100" value="50" class="slider" id="myRange"/>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="dashboardCard">
                        <div className="dashboardCardBody">
                            <div className="dashboardCardHeading">
                                Honeycomb as a Tool
                            </div>
                            <div className="cardBodyText">
                                Embed our button onto your site.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="dashboardCard">
                        <div className="dashboardCardBody">
                            <div className="dashboardCardHeading">
                                Step 1: Customize the Button
                            </div>
                            {this.sizeSelector}
                            {this.colourPalette}
                            {this.displayPicker}
                            {this.createAllButtons}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="dashboardCard">
                        <div className="dashboardCardBody">
                            <div className="dashboardCardHeading">
                                Step 2: Add the Button to your Website
                            </div>
                            <div className="dashboardCardSubHeading">
                                Preferred Method
                            </div>
                            <div className="cardBodyText">
                                Share this piece of code with your website developer
                            </div>
                            {this.codeHighlight}
                            {this.renderClipboardCopier(EMBED_BUTTON_CODE(this.props.restaurantURL, this.state.size, this.state.colour, this.state.display))}
                            <br />
                            <div className="dashboardCardSubHeading">
                                Troubleshooting
                            </div>
                            <div className="cardBodyText">
                                Button not showing up? Having other issues? Contact us or please read our <a href="https://medium.com/@ashaya/b712f737944f">FAQ Tutorials</a> for further instructions.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

EmbedButton.defaultProps = {
    colours: {
        'honeycomb': "#2eb2ff",
        'white': '#f0f0f0',
        'black': "#000",      
        'emerald' : '#54B948', 
        'yellow': "#fa9838", 
        'orange': "#e84118", 
        'darkpink'   : "#C30330", 
        'grey'  : "#353B48",
        'slatewhite': "#f0f0f0",
        'purple': "#271748",
        'pink': "#db4f64",
        'transparent': '#f0f0f0'

    },
    sizes: ['small', 'large'],
    displays: ['left', 'full', 'right']
  };

export default EmbedButton;


// WEBPACK FOOTER //
// ./src/components/EmbedButton/EmbedButton.js